// extracted by mini-css-extract-plugin
export default {"PopupStickedWithSwipeCloseAnimated":"PopupStickedWithSwipeCloseAnimated_PopupStickedWithSwipeCloseAnimated__+EN3u"};